module.exports = __webpack_public_path__ + "static/media/mileage_2_4.530d79d2.png";